import { FaRegCalendarAlt } from 'react-icons/fa'
import { pt } from 'date-fns/locale'
import { LegacyRef, MouseEventHandler, forwardRef } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

import { Icon, InputDatePicker, boxButton, inputRequiredStyle } from './styles'
import { ErrorText, Label } from 'components/InputLabel/styles'
import { Control, Controller } from 'react-hook-form'


interface CustomDatePickerProps {
    id?: string
    dateValue?: Date
    customStyle?: string
    placeholderData: string
    label?: string
    control: Control<any, any>
    required: boolean
    error?: boolean
    errorText?: string;
    minDate?: Date
    maxDate?: Date
    name?: string
    disabled?: boolean,
    isError?: boolean
    ptIcon?: boolean
    startsEmpty?: boolean
    onFocus?: () => void
}
interface DatePickerProps {
    customStyle?: string
    value?: any
    onClick: MouseEventHandler<HTMLInputElement>
    label: string
    error?: boolean
    minDate?: Date
    maxDate?: Date
    isError?: boolean
    name: string
    onChange: () => void
    onFocus?: () => void
    errorText?: string;
}

const CustomDatePicker = ({
    label,
    control,
    required,
    error,
    minDate,
    maxDate,
    name,
    dateValue,
    disabled,
    customStyle,
    isError,
    onFocus,
    id,
    startsEmpty,
    errorText
}: CustomDatePickerProps) => {
    return (
        <Controller
            data-testid="test-datepicker"
            defaultValue={dateValue ?? !startsEmpty ? new Date() : null}
            control={control}
            rules={{ required: required }}
            name={name || 'date'}
            render={({ field: { onChange, value, } }) => {

                return (
                    <DatePicker
                        className={`${id}`}
                        placeholderText={'dd/mm/aaaa'}
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        disabled={disabled}
                        dateFormat="yyyy-MM-dd"
                        locale={pt}
                        onChange={onChange}
                        customInput={
                            <DatePickerInput
                                errorText={errorText}
                                onFocus={() => onFocus()}
                                onClick={() => { }}
                                customStyle={customStyle}
                                label={label}
                                name={name}
                                value={value || new Date()}
                                onChange={onChange}
                                error={error}
                                isError={isError} />
                        }
                        selected={value}
                        value={value || new Date()}
                        selectsStart
                        clearButtonTitle="teste"
                        timeInputLabel="Horas:"
                        minDate={minDate}
                        maxDate={maxDate}
                    />
                )
            }}
        />
    )
}

const DatePickerInput = forwardRef(
    ({
        value,
        onClick,
        customStyle,
        label,
        error,
        isError,
        name,
        onChange,
        onFocus,
        errorText
    }: DatePickerProps,
        ref: LegacyRef<HTMLInputElement> | undefined
    ) => {
        return (
            <div className="relative">
                <Label>{label}</Label>

                <div className={boxButton}>
                    <InputDatePicker
                        onFocus={() => onFocus()}
                        className={`${customStyle} ${error && inputRequiredStyle} ${isError && inputRequiredStyle}`}
                        onClick={onClick}
                        ref={ref}
                        value={value}
                        name={name}
                        type="date"
                        onChange={onChange}
                    />
                    <Icon>
                        <FaRegCalendarAlt size={18} className="text-blueTheme flex items-center" />
                    </Icon>
                </div>

                <ErrorText>{error && (errorText || 'Data inválida')}</ErrorText>
            </div>
        )
    }
)

export { CustomDatePicker }
